export enum IconVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  low = 'low',
  high = 'high',
  current = 'current'
}



export enum IconSize {
  xxs = 'xxs',
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}

export enum IconType {
  filled = 'filled',
  outlined = 'outlined'
}

export type CssClassMap = { [className: string]: boolean };
